import { types } from "../../types/types";

//ESTE ARCHIVO, TANTO EL DE LAS ACTIONS, COMO EL SERVICE, SOLO ES PARA LA PESTAÑA REPORTES
// NO SE PUSO ACA EL NOMENCLADOR, PORQUE SOLO ES UN GET Y NADA MAS
const initialState = {
    contratosRed: [],
    prestadoresPorPractica: [], // REPORTE 2
    prestadoresFiltrados: [], //REPORTE 3
    loading: false,
};

export const contratacionesReportesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.traerContratosRedStart:
            return {
                ...state,
                loading: true,
            };
        case types.traerContratosRedSuccess:
            return {
                ...state,
                contratosRed: action.payload,
                loading: false,
            };
        case types.traerContratosRedError:
            return {
                ...state,
                loading: false,
            };
        case types.traerPrestadoresFiltradosStart:
            return {
                ...state,
                loading: true,
            };
        case types.traerPrestadoresFiltradosSuccess:
            return {
                ...state,
                prestadoresFiltrados: action.payload,
                loading: false,
            };
        case types.traerPrestadoresFiltradosError:
            return {
                ...state,
                loading: false,
            };
        case types.traerPracticaStart:
            return {
                ...state,
                loading: true,
            };
        case types.traerPracticaSuccess:
            return {
                ...state,
                prestadoresPorPractica: action.payload,
                loading: false,
            };
        case types.traerPracticaError:
            return {
                ...state,
                loading: false,
            };
        case types.CleanPractica:
            return {
                ...state,
                prestadoresPorPractica: [],
                loading: false,
            };
        default:
            return state;
    }
};
